<form id="parkerEditForm" [formGroup]="parkerEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="firstname" class="control-label required">{{'i18n.shared.fields.firstname' | translate}}</label>
      <input id="firstname" name="firstname" type="text" autocomplete="off" class="form-control" formControlName="firstName" />
      <app-error-messages [control]="parkerEditForm.controls.firstName"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="lastname" class="control-label required">{{'i18n.shared.fields.lastname' | translate}}</label>
      <input id="lastname" name="lastname" type="text" autocomplete="off" class="form-control" formControlName="lastName" />
      <app-error-messages [control]="parkerEditForm.controls.lastName"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="identification" class="control-label">{{'i18n.domain.parker-administration.overview.fields.identification' | translate}}</label>
      <input id="identification" name="identification" type="text" autocomplete="off" class="form-control" formControlName="identification" />
      <app-error-messages [control]="parkerEditForm.controls.identification"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.domain.parker-administration.overview.fields.group' | translate}}</label>
      <app-enum-drop-down-list formControlName="group"
                              id="group"
                              width="100%"
                              [enumType]="ParkerGroup"
                              [showClearButton]="false"
                              baseTranslationString="i18n.domain.parker-administration.enums.group-type.">
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label required">{{'i18n.domain.parker-administration.overview.fields.entryDate' | translate}}</label>
      <ejs-datepicker id="entryDate" formControlName="entryDate" [showClearButton]="true" format="dd.MM.yyyy"></ejs-datepicker>
      <app-error-messages [control]="parkerEditForm.controls.entryDate"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.domain.parker-administration.overview.fields.exitDate' | translate}}</label>
      <ejs-datepicker id="exitDate" formControlName="exitDate" [showClearButton]="true" [min]="parkerEditForm.controls.entryDate.value" format="dd.MM.yyyy"></ejs-datepicker>
      <app-error-messages [control]="parkerEditForm.controls.exitDate"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.domain.parker-administration.overview.fields.company' | translate}}</label>
      <ejs-dropdownlist id="companyId" [dataSource]="companies" [fields]="dropdownSettings" [showClearButton]="true" formControlName="companyId"></ejs-dropdownlist>
    </div>
    <div class="form-group col-md-4">
      <label for="costCenter" class="control-label">{{'i18n.domain.parker-administration.overview.fields.cost-center' | translate}}</label>
      <input id="costCenter" name="costCenter" type="text" autocomplete="off" class="form-control" formControlName="costCenter" />
      <app-error-messages [control]="parkerEditForm.controls.costCenter"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="title" class="control-label">{{'i18n.domain.parker-administration.overview.fields.title' | translate}}</label>
      <input id="title" name="title" type="text" autocomplete="off" class="form-control" formControlName="title" />
      <app-error-messages [control]="parkerEditForm.controls.title"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="address" class="control-label">{{'i18n.shared.fields.address' | translate}}</label>
      <input id="address" name="address" type="text" autocomplete="off" class="form-control" formControlName="address" />
      <app-error-messages [control]="parkerEditForm.controls.address"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="zip" class="control-label">{{'i18n.shared.fields.zip' | translate}}</label>
      <input id="zip" name="zip" type="text" autocomplete="off" class="form-control" formControlName="zip" />
      <app-error-messages [control]="parkerEditForm.controls.zip"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="city" class="control-label">{{'i18n.shared.fields.city' | translate}}</label>
      <input id="city" name="city" type="text" autocomplete="off" class="form-control" formControlName="city" />
      <app-error-messages [control]="parkerEditForm.controls.city"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.shared.fields.country' | translate}}</label>
      <app-autocomplete #countryAutocomplete
                        [getDataFunction]="getCountries.bind(this)"
                        [(value)]="selectedCountry"
                        [isFormComponent]="true"
                        id="country">
      </app-autocomplete>
      <app-error-messages [control]="parkerEditForm.controls.country"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="email" class="control-label">{{'i18n.shared.fields.email' | translate}}</label>
      <input id="email" name="email" type="text" autocomplete="off" class="form-control" formControlName="email" />
      <app-error-messages [control]="parkerEditForm.controls.email"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="mobile" class="control-label">{{'i18n.domain.parker-administration.overview.fields.mobile' | translate}}</label>
      <input id="mobile" name="mobile" type="text" autocomplete="off" class="form-control" formControlName="mobile" />
      <app-error-messages [control]="parkerEditForm.controls.mobile"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="phone" class="control-label">{{'i18n.domain.parker-administration.overview.fields.phone' | translate}}</label>
      <input id="phone" name="phone" type="text" autocomplete="off" class="form-control" formControlName="phone" />
      <app-error-messages [control]="parkerEditForm.controls.phone"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.domain.parker-administration.overview.fields.billing' | translate}}</label>
      <app-yes-no-group-button id="billing" formControlName="billing"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="workplace" class="control-label">{{'i18n.domain.parker-administration.overview.fields.workplace' | translate}}</label>
      <input id="workplace" name="workplace" type="text" autocomplete="off" class="form-control" formControlName="workplace" />
      <app-error-messages [control]="parkerEditForm.controls.workplace"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="employmentPercentage" class="control-label">{{'i18n.domain.parker-administration.overview.fields.employment-percentage' | translate}}</label>
      <input id="employmentPercentage" name="employmentPercentage" type="number" autocomplete="off" class="form-control" formControlName="employmentPercentage" />
      <app-error-messages [control]="parkerEditForm.controls.employmentPercentage"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.shared.fields.active' | translate}}</label>
      <app-yes-no-group-button id="active" formControlName="active"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label">{{'i18n.domain.parker-administration.detail.billing-currency' | translate}}</label>
      <app-button-group id="billingCurrency"
                        formControlName="billingCurrency"
                        [fieldsEnum]="CurrencyEnum"
                        [translateKey]="'i18n.shared.currencies.'">
      </app-button-group>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label for="visitor-parking-permit-validity-period" class="control-label">{{'i18n.domain.parker-administration.detail.visitor-parking-permit-validity-period' | translate}}</label>
      <input id="visitor-parking-permit-validity-period" name="visitor-parking-permit-validity-period" type="text" autocomplete="off" class="form-control" formControlName="parkingPermitValidityPeriod" />
    </div>
    @if (!isAdd){
      <div class="form-group col-md-8">
        <label for="visitor-parking-permit-code" class="control-label">{{'i18n.domain.parker-administration.detail.visitor-parking-permit-code' | translate}}</label>
        <div class="input-group">
          <input id="visitor-parking-permit-code" name="visitor-parking-permit-code" type="text" autocomplete="off" class="form-control" formControlName="activeParkingPermitGuid" />
          <button class="btn btn-secondary btn-icon e-icons icon-renew" (click)="renewParkingPermitGuid()"></button>
          <button class="btn btn-secondary btn-icon e-icons icon-printer" [disabled]="!parkerEditForm.controls.activeParkingPermitGuid.value" (click)="printParkingPermit()"></button>
        </div>
      </div>
    }
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label for="linked-user" class="control-label">{{'i18n.domain.parker-administration.detail.linked-user' | translate}}</label>
      <input id="linked-user" name="linked-user" type="text" autocomplete="off" class="form-control" formControlName="linkedUser" />
    </div>
    @if (!isAdd){
      <div class="form-group col-md-4">
        <label for="modified-by" class="control-label">{{'i18n.domain.parker-administration.detail.modified-by' | translate}}</label>
        <input id="modified-by" name="modified-by" type="text" autocomplete="off" class="form-control" formControlName="modifiedBy" />
      </div>
      <div class="form-group col-md-4">
        <label for="modified-on" class="control-label">{{'i18n.domain.parker-administration.detail.modified-on' | translate}}</label>
        <input id="modified-on" name="modified-on" type="text" autocomplete="off" class="form-control" formControlName="modifiedOn"/>
      </div>
    }
  </div>
  <ejs-accordion>
    <e-accordionitems>
      <e-accordionitem>
        <ng-template #header>
          <div>{{'i18n.domain.parker-administration.overview.accordions.tags' | translate}}</div>
        </ng-template>
        <ng-template #content>
          <div class="form-row row">
            <div class="form-group col-md-12">
              <app-edit-parker-tags-list [client]="client" [(tags)]="parkerTags"></app-edit-parker-tags-list>
            </div>
          </div>
        </ng-template>
      </e-accordionitem>
      <e-accordionitem>
        <ng-template #header>
          <div>{{'i18n.domain.parker-administration.overview.accordions.subscriptions' | translate}}</div>
        </ng-template>
        <ng-template #content>
          <div class="form-row row">
            <div class="form-group col-md-12">
              <app-edit-parker-subscription-list [(subscriptions)]="parkerSubscriptions" [clientId]="client.id"></app-edit-parker-subscription-list>
            </div>
          </div>
        </ng-template>
      </e-accordionitem>

      <e-accordionitem>
        <ng-template #header>
          <div>{{'i18n.domain.parker-administration.overview.accordions.custom-fields' | translate}}</div>
        </ng-template>
        <ng-template #content>
          <div class="form-row row">
            <div class="form-group col-md-4">
              @if(client.custom1Name){
                <label for="custom1" class="custom1-label">{{client.custom1Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}1)</label>
              } @else {
                <label for="custom1" class="custom1-label">{{'i18n.domain.parker-administration.overview.fields.custom1' | translate}}</label>
              }
              <input id="custom1" name="custom1" type="text" autocomplete="off" class="form-control" formControlName="custom1" />
              <app-error-messages [control]="parkerEditForm.controls.custom1"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              @if(client.custom2Name){
                <label for="custom2" class="custom2-label">{{client.custom2Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}2)</label>
              } @else {
                <label for="custom2" class="custom2-label">{{'i18n.domain.parker-administration.overview.fields.custom2' | translate}}</label>
              }
              <input id="custom2" name="custom2" type="text" autocomplete="off" class="form-control" formControlName="custom2" />
              <app-error-messages [control]="parkerEditForm.controls.custom2"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              @if(client.custom3Name){
                <label for="custom3" class="custom3-label">{{client.custom3Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}3)</label>
              } @else {
                <label for="custom3" class="custom3-label">{{'i18n.domain.parker-administration.overview.fields.custom3' | translate}}</label>
              }
              <input id="custom3" name="custom3" type="text" autocomplete="off" class="form-control" formControlName="custom3" />
              <app-error-messages [control]="parkerEditForm.controls.custom3"></app-error-messages>
            </div>
          </div>

          <div class="form-row row">
            <div class="form-group col-md-4">
              @if(client.custom4Name){
                <label for="custom4" class="custom4-label">{{client.custom4Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}4)</label>
              } @else {
                <label for="custom4" class="custom4-label">{{'i18n.domain.parker-administration.overview.fields.custom4' | translate}}</label>
              }
              <input id="custom4" name="custom4" type="text" autocomplete="off" class="form-control" formControlName="custom4" />
              <app-error-messages [control]="parkerEditForm.controls.custom4"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              @if(client.custom5Name){
                <label for="custom5" class="custom5-label">{{client.custom5Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}5)</label>
              } @else {
                <label for="custom5" class="custom5-label">{{'i18n.domain.parker-administration.overview.fields.custom5' | translate}}</label>
              }
              <input id="custom5" name="custom5" type="text" autocomplete="off" class="form-control" formControlName="custom5" />
              <app-error-messages [control]="parkerEditForm.controls.custom5"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              @if(client.custom6Name){
                <label for="custom6" class="custom6-label">{{client.custom6Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}6)</label>
              } @else {
                <label for="custom6" class="custom6-label">{{'i18n.domain.parker-administration.overview.fields.custom6' | translate}}</label>
              }
              <input id="custom6" name="custom6" type="text" autocomplete="off" class="form-control" formControlName="custom6" />
              <app-error-messages [control]="parkerEditForm.controls.custom6"></app-error-messages>
            </div>
          </div>

          <div class="form-row row">
            <div class="form-group col-md-4">
              @if(client.custom7Name){
                <label for="custom7" class="custom7-label">{{client.custom7Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}7)</label>
              } @else {
                <label for="custom7" class="custom7-label">{{'i18n.domain.parker-administration.overview.fields.custom7' | translate}}</label>
              }
              <input id="custom7" name="custom7" type="text" autocomplete="off" class="form-control" formControlName="custom7" />
              <app-error-messages [control]="parkerEditForm.controls.custom7"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              @if(client.custom8Name){
                <label for="custom8" class="custom8-label">{{client.custom8Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}8)</label>
              } @else {
                <label for="custom8" class="custom8-label">{{'i18n.domain.parker-administration.overview.fields.custom8' | translate}}</label>
              }
              <input id="custom8" name="custom8" type="text" autocomplete="off" class="form-control" formControlName="custom8" />
              <app-error-messages [control]="parkerEditForm.controls.custom8"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              @if(client.custom9Name){
                <label for="custom9" class="custom9-label">{{client.custom9Name}}({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}9)</label>
              } @else {
                <label for="custom9" class="custom9-label">{{'i18n.domain.parker-administration.overview.fields.custom9' | translate}}</label>
              }
              <input id="custom9" name="custom9" type="text" autocomplete="off" class="form-control" formControlName="custom9" />
              <app-error-messages [control]="parkerEditForm.controls.custom9"></app-error-messages>
            </div>
          </div>
        </ng-template>
      </e-accordionitem>
      <e-accordionitem>
        <ng-template #header>
          <div>{{'i18n.domain.parker-administration.overview.accordions.private-address' | translate}}</div>
        </ng-template>
        <ng-template #content>
          <div class="form-row row">
            <div class="form-group col-md-4">
              <label for="privateAddress" class="control-label">{{'i18n.shared.fields.address' | translate}}</label>
              <input id="privateAddress" name="privateAddress" type="text" autocomplete="off" class="form-control" formControlName="privateAddress" />
              <app-error-messages [control]="parkerEditForm.controls.privateAddress"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="privateZip" class="control-label">{{'i18n.shared.fields.zip' | translate}}</label>
              <input id="privateZip" name="privateZip" type="text" autocomplete="off" class="form-control" formControlName="privateZip" />
              <app-error-messages [control]="parkerEditForm.controls.privateZip"></app-error-messages>
            </div>
            <div class="form-group col-md-4">
              <label for="privateCity" class="control-label">{{'i18n.shared.fields.city' | translate}}</label>
              <input id="privateCity" name="privateCity" type="text" autocomplete="off" class="form-control" formControlName="privateCity" />
              <app-error-messages [control]="parkerEditForm.controls.privateCity"></app-error-messages>
            </div>
          </div>
          <div class="form-row row">
            <div class="form-group col-md-4">
              <label class="control-label">{{'i18n.shared.fields.country' | translate}}</label>
              <app-autocomplete #countryAutocomplete
                                [getDataFunction]="getCountries.bind(this)"
                                [(value)]="selectedPrivateCountry"
                                [isFormComponent]="true"
                                id="privateCountry">
              </app-autocomplete>
              <app-error-messages [control]="parkerEditForm.controls.country"></app-error-messages>
            </div>
          </div>
        </ng-template>
      </e-accordionitem>
    </e-accordionitems>
  </ejs-accordion>
  <div class="row mt-3">
    <div class="form-group col-md-12">
      <label for="comment" class="control-label">{{'i18n.domain.parker-administration.overview.fields.comment' | translate}}</label>
      <textarea id="comment" name="comment" class="form-control" formControlName="comment"></textarea>
    </div>
  </div>
</form>
